import React, { useRef, useState } from 'react'
import CTAButton from '../components/cta-button-2'
import { useNavigate } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import YouTube from 'react-youtube';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Marketing() {
  const navigate = useNavigate();
  const [currentSlickIndex, setCurrentSlickIndex] = useState(0); // State to track the current index

  const slick = useRef(null);
  const rand = Math.random() < 0.5 || true;

  const dcImagePaths = [
    "/assets/img/testimonial/dc/1.jpeg",
    "/assets/img/testimonial/dc/2.jpeg",
    "/assets/img/testimonial/dc/3.jpeg",
    "/assets/img/testimonial/dc/4.jpeg",
    "/assets/img/testimonial/dc/5.jpeg",
    "/assets/img/testimonial/dc/6.jpeg",
    "/assets/img/testimonial/dc/7.jpeg",
    "/assets/img/testimonial/dc/8.jpeg",
    "/assets/img/testimonial/dc/9.jpeg",
    "/assets/img/testimonial/dc/10.jpeg",
    "/assets/img/testimonial/dc/11.jpeg",
    "/assets/img/testimonial/dc/12.jpeg",
    "/assets/img/testimonial/dc/13.jpeg",
    "/assets/img/testimonial/dc/14.jpeg",
    "/assets/img/testimonial/dc/15.jpeg",
    "/assets/img/testimonial/dc/16.jpeg",
    "/assets/img/testimonial/dc/17.jpeg",
    "/assets/img/testimonial/dc/18.jpeg",
    "/assets/img/testimonial/dc/19.jpeg",
    "/assets/img/testimonial/dc/19b.jpeg",
    "/assets/img/testimonial/dc/20.jpeg",
    "/assets/img/testimonial/dc/21.jpeg",
    "/assets/img/testimonial/dc/22.jpeg",
    "/assets/img/testimonial/dc/23.jpeg",
    "/assets/img/testimonial/dc/23b.jpeg",
    "/assets/img/testimonial/dc/24.jpeg",
    "/assets/img/testimonial/dc/25.jpeg",
    "/assets/img/testimonial/dc/26.jpeg",
    "/assets/img/testimonial/dc/27.jpeg",
    "/assets/img/testimonial/dc/28.jpeg",
    "/assets/img/testimonial/dc/29.jpeg",
    "/assets/img/testimonial/dc/30.jpeg",
    "/assets/img/testimonial/dc/30a.jpeg",
    "/assets/img/testimonial/dc/30b.jpeg",
    "/assets/img/testimonial/dc/31a.jpeg",
    "/assets/img/testimonial/dc/31b.jpeg",
    "/assets/img/testimonial/dc/32a.jpeg",
    "/assets/img/testimonial/dc/32b.jpeg",
  ];
  const fbImagePaths = [
    "assets/img/testimonial/fb/1.PNG",
    "assets/img/testimonial/fb/2.PNG",
    "assets/img/testimonial/fb/3.PNG",
    "assets/img/testimonial/fb/4.PNG",
    "assets/img/testimonial/fb/5.PNG",
    "assets/img/testimonial/fb/6.PNG",
    "assets/img/testimonial/fb/7.PNG",
    "assets/img/testimonial/fb/8.PNG",
    "assets/img/testimonial/fb/9.PNG",
    "assets/img/testimonial/fb/10.PNG",
    "assets/img/testimonial/fb/11.PNG",
    "assets/img/testimonial/fb/12.PNG",
    "assets/img/testimonial/fb/13.PNG",
    "assets/img/testimonial/fb/14.PNG",
    "assets/img/testimonial/fb/15.PNG",
    "assets/img/testimonial/fb/16.PNG",
    "assets/img/testimonial/fb/17.PNG",
    "assets/img/testimonial/fb/18.PNG",
  ];

  const memberTestimonials = [
    "_1Sy1QUEzsk",
    "z5lxKo5P1Ss",
    "mEZqDVeaWYo",
    "EecOcoJjynY",
    "CYc5l0GmiO4",
    "syPagyHKFVo",
  ];

  const slickCarouselSettings = {
    infinite: true, // Infinite scrolling
    speed: 500, // Transition speed
    slidesToShow: 3, // Number of visible slides
    slidesToScroll: 1, // Number of slides to scroll
    arrows: false, // Show navigation arrows
    // autoplay: true, // Auto scroll
    centerMode: false,
    autoplaySpeed: 2 * 1000, // Autoplay delay in milliseconds
    centerPadding: "0", // Remove additional padding
    initialSlide: 0, // Start with the first slide
    afterChange: (current) => setCurrentSlickIndex(current), // Update the current index
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 530,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      {/* NavBar */}
      <div className='flex justify-between items-center fixed top-0 left-0 w-screen h-auto backdrop-blur py-4 px-12 [&>div]:flex-1 [&>div]:w-full z-[100] max-[900px]:px-6'>
        {/* NavBar Start */}
        <div className='flex gap-8 items-center [&>a]:transition-all [&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:font-semibold max-[900px]:hidden'>
          <a href="#home">Home</a>
          <a href="#why">Why</a>
          <a href="#member_testimonial">Testimonial</a>
        </div>
        {/* NavBar Center */}
        <div className='flex-center max-[900px]:items-start'>
          <h1 className='font-semibold text-lg'>
            JS Tradventures
          </h1>
        </div>
        {/* NavBar End */}
        <div className='flex justify-end'>
          <a href="https://chat.whatsapp.com/JbLJIFmEVjG7pFORGda6ZY" target='_blank' rel="noreferrer">
            <button className='transition-all border-2 border-black bg-black text-white px-8 py-1 rounded-full hover:bg-white hover:text-black '>Join Us</button>
          </a>
        </div>
      </div>
      <main className='relative flex-center gap-0 text-[14px] md:text-[16px] lg:text-[16px]'>
        <div className='w-24 fixed bottom-0 left-0 z-[100] rounded-full -translate-x-0 translate-y-0 hidden max-[800px]:block'>
          <CTAButton />
        </div>

        {/* Hero Section */}
        <div id='home' className='page-size py-4 px-12 pt-20 flex-center justify-end gap-4 max-[920px]:p-4 max-[800px]:justify-start'>
          <div className='mt-14 bg-black text-white hidden flex-col justify-between p-6 rounded-custom w-full max-[860px]:flex'>
            <p className='text-2xl text-nowrap mr-12'>Access to our<br />E-Learning System</p>
            <div className='h-12' />
            <div className='flex flex-row items-end justify-between'>
              <img src="/assets/icon/star.svg" className='w-12' alt="star icon" />
              <button onClick={() => { navigate("/home") }} className='transition-all px-8 py-2 border-1 rounded-full hover:bg-white hover:text-black horver:font-bold'>
                Login
              </button>
            </div>
          </div>
          <div className='flex flex-row w-full'>
            <div className='flex flex-col justify-end w-full'>
              <p className='hero-big-text flex flex-row items-center gap-2 self-start max-[800px]:pb-4'>
                LEARN
                <div className='inline border-black border-1 shadow-sm rounded-full px-8 py-2 font-extralight hero-sub-text'>
                  AND
                </div>
              </p>
              <p className='hero-big-text self-center max-[800px]:self-start'>ENHANCE</p>
            </div>
            <div className='bg-black text-white flex flex-col justify-between p-8 rounded-custom max-[860px]:hidden'>
              <p className='text-2xl text-nowrap mr-12'>Access to our<br />E-Learning System</p>
              <div className='h-12' />
              <div className='flex flex-row items-end justify-between'>
                <img src="/assets/icon/star.svg" className='w-12' alt="star icon" />
                <button onClick={() => { navigate("/home") }} className='transition-all px-8 py-2 border-1 rounded-full hover:bg-white hover:text-black horver:font-bold'>
                  Login
                </button>
              </div>
            </div>
          </div>
          <div className='flex flex-row justify-end items-center w-full max-[800px]:justify-start'>
            <p className='hero-big-text text-nowrap'>TRADING SKILLS</p>
          </div>

          <div className="flex flex-row w-full gap-4 h-[18rem] max-[800px]:flex-col max-[800px]:h-auto">
            <div className='flex flex-col gap-4 w-[40%] max-[800px]:w-full max-[800px]:flex-col-reverse'>
              <div className='relative bg-base-200 p-8 rounded-custom h-full flex-center items-end w-full max-[800px]:p-6'>
                <p className='text-end w-full max-[800px]:text-start'>
                  We share experience and <br className='max-[800px]:hidden' />education on trading financial <br className='max-[800px]:hidden' />assets to acclerate trader's adventure.
                </p>
                <div className='absolute top-0 -translate-y-10 left-[2vw] w-32 max-[800px]:hidden'>
                  <CTAButton />
                </div>
              </div>
              <div className="flex flex-row  gap-4 h-full [&>div]:py-4 [&>div]:w-full [&>div]:bg-base-200 [&>div]:h-full  [&>div]:flex [&>div]:flex-col [&>div]:justify-center [&>div]:items-center [&>div>h6]:font-bold [&>div>h6]:text-2xl [&>div>p]:text-md ">
                <div className="rounded-custom">
                  <h6>100K</h6>
                  <p>Users</p>
                </div>
                <div className="rounded-custom">
                  <h6>32K</h6>
                  <p>Profits</p>
                </div>
                <div className="rounded-custom !bg-black text-white">
                  <h6>80K</h6>
                  <p>Classes</p>
                </div>
              </div>
            </div>
            <div className='w-[60%] rounded-custom h-full relative max-[800px]:w-full'>
              <img src="/assets/img/hero_1.png" className='w-full h-full rounded-custom' alt="" />
              <img src={rand ? "/assets/img/hero_2.png" : "/assets/img/hero_3.png"} className={'absolute bottom-0 left-1/2 -translate-x-1/2 min-w-[200px] max-[800px]:w-1/3' + (!rand ? "-ml-8" : "")} alt="" />
            </div>
          </div>
        </div>
        <br />
        <br />
        {/* Why Us */}
        <div className="page-size !min-h-0 flex-center p-12 relative gap-2 max-[920px]:p-4" id='why'>
          <div className='flex flex-row gap-4 items-end '>
            <div className='translate-y-12 w-[7rem] max-[800px]:hidden '>
              <CTAButton />
            </div>
            <p className="text-title text-nowrap max-[800px]:text-5xl ">WHY US</p>
            <img className='max-[800px]:absolute top-0 right-0 max-[800px]:translate-x-0 max-[800px]:w-16' src="/assets/icon/fan.svg" alt="" />
          </div>
          <div className='flex flex-row justify-center items-center gap-2 max-[1300px]:flex-col'>
            <div className='flex-center items-end gap-2'>
              <div className="flex flex-row gap-2 justify-end items-end max-[800px]:flex-col max-[800px]:pt-12">
                <img className='w-[20rem] border-black border-2 transition-all hover:scale-[1.025] rounded-custom py-4 max-[800px]:w-[90%] max-[800px]:self-center max-[800px]:mb-4 max-[800px]:max-w-none max-[800px]:h-auto' src="/assets/img/why/1.jpg" alt="" />
                <img className='w-[20rem] border-black border-2 transition-all hover:scale-[1.025] rounded-custom p-4 bg-black max-[800px]:w-[90%] max-[800px]:self-center max-[800px]:mb-4 max-[800px]:max-w-none max-[800px]:h-auto' src="/assets/img/why/3.jpg" alt="" />
              </div>
              <div className="flex flex-row gap-2 justify-end items-start max-[800px]:flex-col">
                <img className='w-[24rem] border-black border-2 transition-all hover:scale-[1.025] rounded-custom py-4 bg-black max-[1300px]:w-auto max-[1300px]:h-[11rem] max-[800px]:w-[90%] max-[800px]:self-center max-[800px]:mb-4 max-[800px]:max-w-none max-[800px]:h-auto' src="/assets/img/why/5.jpg" alt="" />
                <img className='w-[18rem] border-black border-2 transition-all hover:scale-[1.025] rounded-custom py-4 bg-[#252525] max-[1300px]:w-auto max-[1300px]:h-[11rem] max-[800px]:w-[90%] max-[800px]:self-center max-[800px]:mb-4 max-[800px]:max-w-none max-[800px]:h-auto' src="/assets/img/why/6.jpg" alt="" />
              </div>
            </div>
            <div className='flex-center items-start max-[800px]:w-[90%] max-[800px]:self-center max-[800px]:mb-4 max-[800px]:max-w-none'>
              <img className='w-[20rem] border-black border-2 transition-all hover:scale-[1.025] rounded-custom py-4 bg-black max-[800px]:w-[100%] max-[800px]:self-center max-[800px]:mb-4 max-[800px]:max-w-none max-[800px]:h-auto' src="/assets/img/why/4.jpg" alt="" />
            </div>
          </div>
        </div>

        {/* Community Benefit: Not included in this page*/}

        {/* Timeline */}
        <div className="page-size flex-center py-4 px-12 max-[920px]:p-4" id='timeline'>
          <p className='text-title max-[800px]:text-5xl'>TIMELINE</p>
          <div className='flex flex-col gap-4 [&>div]:h-full [&>div>div]:z-10 [&>div>div:hover]:translate-y-0.5  [&>div>div:nth-child(2)]:px-7 [&>div]:flex [&>div]:justify-center [&>div]:items-center [&>div:nth-child(odd)>div]:text-end [&>div]:gap-2 [&>div>div]:rounded-custom [&>div>div:nth-child(2)]:bg-base-300 [&>div>div:nth-child(1)]:bg-black [&>div>div:nth-child(1)]:text-white'>
            <div className='relative flex-row-reverse max-[800px]:flex-col'>
              <div className='flex-center h-24 text-[3rem] z-10 max-[800px]:text-[2rem] px-14 max-[800px]:py-2 max-[800px]:px-8 max-[800px]:h-auto max-[800px]:self-end'>
                2010
              </div>
              <div className='flex-center h-24 max-w-[29rem] z-10 max-[800px]:w-full max-[800px]:max-w-[30rem] max-[800px]:!text-justify max-[800px]:h-auto max-[800px]:py-2'>
                <p>
                  Started trading in the US stock market as a college student. Faced an <b>RM100k</b> loss but managed to recover 3x the losses before returning from the US.
                </p>
              </div>
              <span className='absolute text-red-300 -right-[0rem] -top-10 z-0 text-title'>
                {"#"}
              </span>
            </div>
            <div className='relative flex-row max-[800px]:flex-col'>
              <div className='flex-center h-24 text-[3rem] max-[800px]:text-[2rem] px-14 max-[800px]:py-2 max-[800px]:px-8 max-[800px]:h-auto max-[800px]:self-start'>
                2014
              </div>
              <div className='flex-center h-24 max-w-sm max-[800px]:w-full max-[800px]:max-w-[30rem] max-[800px]:!text-justify max-[800px]:h-auto max-[800px]:py-2'>
                <p>
                  Transitioned from trading US stocks to diving into the cryptocurrency market.
                </p>
              </div>
              <span className='absolute text-red-300 left-[2rem] -bottom-[3rem] z-0 text-title max-[800px]:-bottom-0 max-[800px]:translate-y-1/2'>
                {"@"}
              </span>
            </div>
            <div className='flex-row-reverse max-[800px]:flex-col'>
              <div className='flex-center h-24 text-[3rem] max-[800px]:text-[2rem] px-14 max-[800px]:py-2 max-[800px]:px-8 max-[800px]:h-auto max-[800px]:self-end'>
                2016
              </div>
              <div className='flex-center h-24 max-w-[30rem] max-[800px]:w-full max-[800px]:max-w-[30rem] max-[800px]:!text-justify max-[800px]:h-auto max-[800px]:py-2'>
                <p>
                  Achieved a significant milestone by hitting the first <b>RM1 million</b> benchmark in cryptocurrency trading.
                </p>
              </div>
            </div>
            <div className='relative flex-row max-[800px]:flex-col'>
              <div className='flex-center h-24 text-[3rem] max-[800px]:text-[2rem] px-14 max-[800px]:py-2 max-[800px]:px-8 max-[800px]:h-auto max-[800px]:self-start'>
                21~24
              </div>
              <div className='flex-center h-24 max-w-[25rem] max-[800px]:w-full max-[800px]:max-w-[30rem] max-[800px]:!text-justify max-[800px]:h-auto max-[800px]:py-2'>
                <p>
                  Recognized as a <b>VIP Trader</b> with multiple leading exchanges, showcasing consistent performance.
                </p>
              </div>
              <span className='absolute text-red-300 -right-[1rem] -top-[50] z-0 text-[6.7rem]'>
                {"*"}
              </span>
            </div>
            <div className='relative flex-row-reverse max-[800px]:flex-col'>
              <div className='flex-center h-24 text-[3rem] max-[800px]:text-[2rem] px-14 max-[800px]:py-2 max-[800px]:px-8 max-[800px]:h-auto max-[800px]:self-end'>
                2024
              </div>
              <div className='flex-center h-24 max-w-[26rem] max-[800px]:w-full max-[800px]:max-w-[30rem] max-[800px]:!text-justify max-[800px]:h-auto max-[800px]:py-2'>
                <p>
                  Founded the <b>JS Tradventures</b> community to promote technical and effective trading through Discord and offline gatherings.
                </p>
              </div>
              <span className='absolute text-red-300 left-[2rem] -bottom-[3rem] z-0 text-title max-[800px]:-bottom-0 max-[800px]:-translate-y-1/3'>
                {"$"}
              </span>
              <span className='absolute text-red-300 -right-[4rem] top-[1rem] z-0 text-title w-[8.7rem]'>
                <CTAButton />
              </span>
            </div>
            <div className='flex-row max-[800px]:flex-col'>
              <div className='flex-center h-24 text-[3rem] max-[800px]:text-[2rem] px-14 max-[800px]:py-2 max-[800px]:px-8 max-[800px]:h-auto max-[800px]:self-start'>
                2025
              </div>
              <div className='flex-center h-24 max-w-[34rem] max-[800px]:w-full max-[800px]:max-w-[30rem] max-[800px]:!text-justify max-[800px]:h-auto max-[800px]:py-2'>
                <p>
                  Celebrating 15 years of trading excellence. Leveraging our experience to empower others and accelerate their trading journey 15x through the JS Community.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Member Testimonial */}
        <div className="page-size flex-center p-12 max-[920px]:p-4" id='member_testimonial'>
          <div className="flex flex-row gap-4 justify-end items-end w-full max-[1000px]:flex-col">
            <div className='flex flex-row items-end rounded-custom z-10 p-4 max-[1000px]:self-center max-[1000px]:flex-col'>
              <p className="text-title leading-none max-[800px]:text-5xl">TESTIMONIAL</p>
              <p className='bg-white text-black border-2 font-semibold border-black rounded-full py-1 px-4 -ml-4 relative max-[1000px]:ml-0 max-[1000px]:-translate-y-2'>
                MEMBER
                <div className='absolute top-0 left-1/2 w-[7rem] -translate-y-full -translate-x-1/2 max-[1000px]:hidden'>
                  <CTAButton />
                </div>
              </p>
            </div>
            <div className="bg-black text-white py-4 px-8 rounded-t-custom h-min relative">
              <img src="/assets/icon/wave.svg" alt="" className='translate-y-4 max-w-36' />
              <div className='absolute bottom-0 left-0 -translate-x-full w-[2rem] h-[2rem] bg-black ' >
                <div className='w-full h-full rounded-br-full bg-white' />
              </div>
            </div>
          </div>
          <div className='bg-black text-white rounded-custom w-full rounded-tr-none relative'>
            <p className="absolute bottom-4 right-6">{"more →"}</p>
            <div className="flex flex-row justify-center items-center w-full h-[24rem] overflow-clip max-[800px]:h-[40vw] max-[530px]:h-[70vw]">
              <Slider ref={slick} {...slickCarouselSettings} className='w-full translate-x-12 max-[530px]:translate-x-0 max-[530px]:w-[90%]'>
                {

                  memberTestimonials.map((memberTestimonial, index) => {
                    return (
                      <div className='carousel-item aspect-video bg-base-200 rounded-md' key={index}>
                        <YouTube
                          videoId={memberTestimonial}
                          iframeClassName='h-full w-full aspect-video rounded-md h-full w-full'
                          className='rounded-md'
                          opts={{
                            playerVars: {
                              autoplay: false,
                            }
                          }}
                        />
                      </div>
                    )
                  })
                }
              </Slider>
            </div>
          </div>
          <div className='flex flex-row gap-1 pt-2 justify-end w-full [&>*]:bg-black [&>*]:text-white [&>*]:px-4 [&>*]:py-2 [&>*]:rounded-full'>
            <button className='flex-center max-[800px]:w-full' onClick={() => slick?.current?.slickPrev()}>
              <ChevronLeft />
            </button>
            <div className='flex-center max-[800px]:w-full'>
              {currentSlickIndex + 1} / {memberTestimonials.length}
            </div>
            <button className='flex-center max-[800px]:w-full' onClick={() => slick?.current?.slickNext()}>
              <ChevronRight />
            </button>
          </div>
        </div>

        {/* Our Community */}
        <div id='community' className="page-size flex-center w-full px-12 py-4 max-[920px]:p-4">
          <p className="text-title max-[800px]:text-5xl max-[800px]:text-center max-[800px]:pb-4">OUR COMMUNITY</p>
          <div className='flex-center w-full max-w-[70rem] bg-black text-white p-4 pb-0 rounded-custom overflow-hidden relative'>
            <br />
            <p className='text-center'>
              Take the first step to join us. <br />
              We will cover everything for you.
            </p>
            <br />
            <img className='w-full max-w-[55rem] rounded-t-md' src="/assets/img/community.png" alt="" />
            <div className='absolute top-[1.5rem] left-[1.5rem] w-16 h-16 -rotate-[9deg] max-[800px]:w-8'>
              <img src="/assets/icon/triangle-2.svg" alt="simple icon" />
            </div>
            <div className='absolute bottom-[1rem] right-[1rem] w-28 invert max-[800px]:hidden'>
              <CTAButton />
            </div>
          </div>
        </div>

        {/* Result Testimonial */}
        <div className="page-size p-12 flex-center items-center max-[920px]:p-4 max-[800px]:px-0 max-[800px]:mb-24">
          <div className="flex flex-row gap-12 justify-center items-center">
            <div className='flex flex-col items-end gap-2'>
              <div className="flex flex-row w-full items-center gap-4 bg-black text-white rounded-custom py-4 px-12 relative max-[800px]:px-8">
                <img className='max-[620px]:absolute top-0 left-0 max-[620px]:-translate-x-1/2 max-[620px]:-translate-y-1/2 max-[620px]:w-8 shadow-sm' src="/assets/icon/lightning.svg" alt="" />
                <p className="text-title leading-none max-[800px]:text-5xl">TESTIMONIAL</p>
              </div>
              <p className='bg-black text-white  px-4 py-2 rounded-full'>RESULT</p>
            </div>
          </div>
          <div className='overflow-clip relative w-full max-h-[36rem] -translate-y-12 max-[800px]:overflow-visible max-[800px]:max-h-none'>
            <div className='bg-base-200 rounded-custom h-[60%] absolute bottom-0 left-0 w-full z-0 max-[800px]:hidden' />
            <div className="absolute bottom-0 left-2 w-[8rem] z-20 drop-shadow-sm max-[800px]:hidden">
              <CTAButton />
            </div>
            <div className=' flex flex-row w-full justify-center items-center max-[800px]:flex-col max-[800px]:pt-24'>
              {/* Large Device */}
              <div className='translate-y-12 z-10 w-[35%] max-w-[28rem] max-[800px]:hidden'>
                <svg className='w-full h-full' viewBox="0 0 376 793" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="-1" y="1" width="373.18" height="791" rx="68" transform="matrix(-1 0 0 1 373.18 0)" fill="black" stroke="#DDDDDD" strokeWidth="2" />
                  <g clipPath="url(#clip0_125_631)">
                    <rect width="351" height="768" rx="62" transform="matrix(-1 0 0 1 363.18 12)" fill="#1C1D22" />
                    <foreignObject
                      x={12}
                      y={12}
                      width={351}
                      height={768}
                    >
                      <div className='w-full h-full bg-red rounded-[62px] overflow-clip p-4'>
                        <div className='w-full h-full flex-center justify-start overflow-y-auto ignore-lenis pt-12'>
                          <p className='text-white'>Discord</p>
                          {
                            dcImagePaths.map((path, index) => {
                              return (
                                <img key={index} className='w-full object-contain object-center max-w-[55rem] border-b-2 border-white py-2' src={path} alt="" />
                              )
                            })
                          }
                        </div>
                      </div>

                    </foreignObject>
                  </g>
                  <rect width="112.219" height="31.8541" rx="15.9271" transform="matrix(-1 0 0 1 244.537 30.1763)" fill="black" />
                  <rect width="18.424" height="18.4419" rx="9.212" transform="matrix(-1 0 0 1 157.441 36.8828)" fill="#D9D9D9" fillOpacity="0.5" />
                  <path d="M222.764 3.35205L152.417 3.35205V3.35205C152.417 5.2039 153.919 6.70512 155.771 6.70512L219.411 6.70512C221.262 6.70512 222.764 5.2039 222.764 3.35205V3.35205Z" fill="#D9D9D9" />
                  <defs>
                    <clipPath id="clip0_125_631">
                      <rect width="768" height="351" fill="white" transform="matrix(0 -1 -1 0 363.18 780)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div className='translate-y-24 w-[35%] max-w-[28rem] max-[800px]:hidden'>
                <svg className='w-full h-full' viewBox="0 0 376 793" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="-1" y="1" width="373.18" height="791" rx="68" transform="matrix(-1 0 0 1 373.18 0)" fill="black" stroke="#DDDDDD" strokeWidth="2" />
                  <g clipPath="url(#clip0_125_631)">
                    <rect width="351" height="768" rx="62" transform="matrix(-1 0 0 1 363.18 12)" fill="#FFFFFF" />
                    <foreignObject
                      x={12}
                      y={12}
                      width={351}
                      height={768}
                    >
                      <div className='w-full h-full bg-red rounded-[62px] overflow-clip p-4'>
                        <div className='w-full h-full flex-center justify-start overflow-y-auto ignore-lenis pt-12'>
                          <p>Facebook</p>
                          {
                            fbImagePaths.map((path, index) => {
                              return (
                                <img key={index} className='w-full object-contain object-center max-w-[55rem] border-b-2 border-black py-2' src={path} alt="" />
                              )
                            })
                          }
                        </div>
                      </div>

                    </foreignObject>
                  </g>
                  <rect width="112.219" height="31.8541" rx="15.9271" transform="matrix(-1 0 0 1 244.537 30.1763)" fill="black" />
                  <rect width="18.424" height="18.4419" rx="9.212" transform="matrix(-1 0 0 1 157.441 36.8828)" fill="#D9D9D9" fillOpacity="0.5" />
                  <path d="M222.764 3.35205L152.417 3.35205V3.35205C152.417 5.2039 153.919 6.70512 155.771 6.70512L219.411 6.70512C221.262 6.70512 222.764 5.2039 222.764 3.35205V3.35205Z" fill="#D9D9D9" />
                  <defs>
                    <clipPath id="clip0_125_631">
                      <rect width="768" height="351" fill="white" transform="matrix(0 -1 -1 0 363.18 780)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              {/* Small Device (iPhone Rotate Right) */}
              <div className='w-full -translate-x-[1.5rem] hidden max-[800px]:block'>
                <svg className='w-full' viewBox="0 0 793 376" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="-1" y="-1" width="373.18" height="791" rx="68" transform="matrix(0 -1 -1 0 791 373.18)" fill="black" stroke="#DDDDDD" stroke-width="2" />
                  <g clip-path="url(#clip0_125_631)">
                    <rect width="351" height="768" rx="62" transform="matrix(0 -1 -1 0 781 363.18)" fill="#1C1D22" />
                    <foreignObject
                      x={66}
                      y={12}
                      width={668 * .9}
                      height={351}
                    >
                      <div className='w-full h-full bg-red rounded-[62px] overflow-clip p-4'>
                        <div className='w-full h-full flex-center justify-start overflow-y-auto ignore-lenis pt-12'>
                          <p className='text-white text-3xl font-semibold'>Discord</p>
                          {
                            dcImagePaths.map((path, index) => {
                              return (
                                <img key={index} className='w-full object-contain object-center max-w-[55rem] border-b-2 border-white py-2' src={path} alt="" />
                              )
                            })
                          }
                        </div>
                      </div>

                    </foreignObject>
                  </g>
                  <rect width="112.219" height="31.8541" rx="15.9271" transform="matrix(0 -1 -1 0 762.823 244.537)" fill="black" />
                  <rect width="18.424" height="18.4419" rx="9.212" transform="matrix(0 -1 -1 0 756.117 157.441)" fill="#D9D9D9" fill-opacity="0.5" />
                  <path d="M789.648 222.763V152.417V152.417C787.797 152.417 786.295 153.918 786.295 155.77V219.41C786.295 221.262 787.797 222.763 789.648 222.763V222.763Z" fill="#D9D9D9" />
                  <defs>
                    <clipPath id="clip0_125_631">
                      <rect width="768" height="351" fill="white" transform="matrix(1 0 0 -1 13 363.18)" />
                    </clipPath>
                  </defs>
                </svg>

              </div>
              <br />
              <br />
              <div className='w-full translate-x-[1.5rem]  hidden max-[800px]:block'>
                <svg className='w-full' viewBox="0 0 793 376" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="1" y="1" width="373.18" height="791" rx="68" transform="matrix(0 1 1 0 0 0)" fill="black" stroke="#DDDDDD" stroke-width="2" />
                  <g clip-path="url(#clip0_179_7)">
                    <rect width="351" height="768" rx="62" transform="matrix(0 1 1 0 12 12)" fill="white" />
                    <foreignObject
                      x={66}
                      y={12}
                      width={668 * .9}
                      height={351}
                    >
                      <div className='w-full h-full bg-red rounded-[62px] overflow-clip p-4'>
                        <div className='w-full h-full flex-center justify-start overflow-y-auto ignore-lenis pt-12'>
                          <p className='text-3xl font-semibold'>Facebook</p>
                          {
                            fbImagePaths.map((path, index) => {
                              return (
                                <img key={index} className='w-full object-contain object-center max-w-[55rem] border-b-2 border-white py-2' src={path} alt="" />
                              )
                            })
                          }
                        </div>
                      </div>

                    </foreignObject>
                  </g>
                  <rect width="112.219" height="31.8541" rx="15.9271" transform="matrix(0 1 1 0 30.1768 130.643)" fill="black" />
                  <rect width="18.424" height="18.4419" rx="9.212" transform="matrix(0 1 1 0 36.8828 217.738)" fill="#D9D9D9" fill-opacity="0.5" />
                  <path d="M3.35156 152.417V222.763V222.763C5.20341 222.763 6.70463 221.261 6.70463 219.41V155.77C6.70463 153.918 5.20341 152.417 3.35156 152.417V152.417Z" fill="#D9D9D9" />
                  <defs>
                    <clipPath id="clip0_179_7">
                      <rect width="768" height="351" fill="white" transform="matrix(-1 0 0 1 780 12)" />
                    </clipPath>
                  </defs>
                </svg>
              </div>








            </div>
          </div>
        </div>

        {/* Footer */}
        <div className='bg-black text-white w-full max-w-[98%] rounded-custom rounded-b-none p-12 flex flex-col md:flex-row justify-around items-center max-[920px]:p-4 max-[920px]:py-12 max-[920px]:max-w-none'>
          <div>
            <h1 className='text-3xl font-semibold py-12'>JS Tradventures</h1>
          </div>
          <div className='flex flex-row min-w-[50%] justify-around gap-4 max-[768px]:min-w-full'>

            <div className='flex flex-col gap-2 [&>a]:underline [&>a]:underline-offset-4 [&>a]:pl-1 [&>a:hover]:font-semibold'>
              <p className='font-semibold'>Navigations</p>
              <a href="#home">Home</a>
              <a href="#why">Why Us</a>
              <a href="#benefit">Benefits</a>
              <a href="#member_testimonial">Testimonial</a>
              <a href="#timeline">Timeline</a>
              <a href="#community">Community</a>
            </div>
            <div className='flex flex-col gap-2 [&>a]:underline [&>a]:underline-offset-4 [&>a]:pl-1 [&>a:hover]:font-semibold'>
              <p className='font-semibold'>Contact Us</p>
              <a target='_BLANK' rel={"noreferrer"} href="https://discord.gg/9FBtyRpSHw">Discord</a>
              <a target='_BLANK' rel={"noreferrer"} href="https://www.facebook.com/profile.php?id=61560315221726&mibextid=LQQJ4d">Facebook</a>
              <a target='_BLANK' rel={"noreferrer"} href="https://www.instagram.com/jstradventures">Instagram</a>
              <a target='_BLANK' rel={"noreferrer"} href="https://t.me/+h2HVoJhHT004ODA1">Telegram</a>
              <a target='_BLANK' rel={"noreferrer"} href="https://www.threads.net/@jstradventures">Threads</a>
              <a target='_BLANK' rel={"noreferrer"} href="https://x.com/Tradventur21084">X (Twitter)</a>
            </div>
          </div>
        </div>
      </main >
    </>
  )
}
